import { makeStyles, createStyles, MuiTheme, color } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    signinViewOuterContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '879px',
      background: 'white',
      color: '#2A2A2A',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      minWidth: '100%',
      borderRadius: '8px',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        height: '1700px'
      },
      [theme.breakpoints.only('lg')]: {
        height: '600px'
      }
    },
    signinViewInnerContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.only('lg')]: {
        justifyContent: 'space-evenly'
      }
    },
    signinViewTextBlock: {
      background: 'transparent',
      margin: '80px 0px 32px 0px',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        margin: '135px 0px 40px 0px'
      },
      [theme.breakpoints.only('lg')]: {
        margin: '80px 0px 10px 0px'
      }
    },
    signinViewInputEmailBlock: {
      padding: '0px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > * > * > * > input': {
        [theme.breakpoints.only('lg')]: {
          minWidth: '430px'
        }
      }
    },
    signinViewInputPasswordBlock: {
      padding: '0px 14px 5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > * > * > * > input': {
        [theme.breakpoints.only('lg')]: {
          minWidth: '430px'
        }
      }
    },
    signinKeyboardBox: {
      '& > * ': {
        [theme.breakpoints.only('lg')]: {
          height: '460px'
        }
      },
      '& > * > * > * ': {
        [theme.breakpoints.only('lg')]: {
          height: '460px'
        }
      }
    },
    signinViewText: {
      fontSize: '64px',
      fontWeight: 600,
      fontFamily: 'Poppins, sans-serif',
      margin: '0px',
      textAlign: 'center'
    },
    muiTextField: {
      height: '100%',
      // override mui styling for default, on hover, on focus, on error
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border: '1px solid #DDDDDD'
        },
        '&:hover fieldset': {
          border: '1px solid #DDDDDD'
        },
        '&.Mui-focused fieldset': {
          border: '1px solid #DDDDDD',
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15) inset'
        },
        '&[data-valid="true"] fieldset': {
          border: '1px solid #DDDDDD'
        },
        '&[data-valid="true"]:hover fieldset': {
          border: '1px solid #DDDDDD'
        },
        '&.Mui-error fieldset': {
          borderColor: color.RED
        }
      }
    },
    input: {
      borderRadius: '50px',
      textAlign: 'center',
      minWidth: '600px',
      padding: '0px 40px 0px 40px',
      height: '104px',
      fontFamily: 'Poppins, sans-serif',
      fontSize: '40px',
      fontWeight: 600
    },
    helpText: {
      fontWeight: 'normal',
      color: `${color.RED} !important`,
      fontSize: '24px',
      textAlign: 'center',
      fontFamily: 'Poppins, sans-serif'
    }
  })
);
